define(
  'pageSizeHandler',[
    'paramsObserver',
    'trackerSearchPagination'
  ],
  (paramsObserver) => {
    'use strict';

    const resultList = document.querySelector('[data-container-results]');
    /**
    *Event delegation to handle global change events inside the results container
    *used this to avoid having to attach multiple events when new pages are loaded via ajax
    */
    resultList.addEventListener('change', (event) => {
      if (event.target.id === 'nhs_PageCountSelect') {
        const currentValue = paramsObserver.getParameter('PageSize');
        const size = parseInt(event.target.value, 10);

        if (size !== currentValue) {
          paramsObserver.setParameter('PageNumber', 1);
          paramsObserver.setParameter('PageSize', size);
          paramsObserver.commit();
          window.NewHomeSource.TrackerSearchPagination.pageSizeSelectionTracker(size);
        }
      }
    });
  }
);

